<template>
  <PopupBox :popup-styles="{ top: 3 }" class="task-period-selector-wrapper" placement="bottom-end" @visibility-change="handlePopupVisibilityChange">
    <template v-slot:trigger>
      <h2 class="task-period-selector"><slot /><PopupToggler :is-open="popupVisible" class="ml-2" /></h2>
    </template>
    <template>
      <PopupMenuList :items="taskPeriods" :selected-item="selectedPeriods" class="task-period-selector-menu" />
    </template>
  </PopupBox>
</template>

<script>
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    taskPeriods: {
      type: Array,
      required: true,
    },
    selectedPeriods: {
      type: Object,
      required: false,
      default: () => {
      },
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupMenuList, PopupToggler },
};
</script>

<style lang="scss" scoped>
.task-period-selector {
  font-family: inherit;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  &-menu {
    border: 1px solid #E5E5E7;
    border-radius: 6px;
    padding: 12px 8px;
    box-shadow: 0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A;
  }
}
</style>
